import React, { useEffect, useState } from "react";
import styles from "./WavePurchase.module.css";
import {
  AiOutlineUp,
  AiOutlineMinus,
  AiOutlinePlus,
  AiOutlineDown,
} from "react-icons/ai";
import EventAccessCode from "@components/Event/EventAccessCode/EventAccessCode";
import Markdown from "markdown-to-jsx";
import VerifyEmail from "@components/VerifyEmail/VerifyEmail";
import {
  MdOutlineKeyboardArrowDown,
  MdOutlineKeyboardArrowUp,
} from "react-icons/md";
import Cookies from "js-cookie";

const WavePurchase = (props) => {
  const {
    waves,
    currency,
    maxPerOrder,
    onQuantityChange,
    quantities,
    handleIncrement,
    handleDecrement,
    name,
    event,
    ticket,
    type,
    handleOpenCloseSeating,
    minPerOrder,
  } = props;
  const [accessGranted, setAccessGranted] = useState(!ticket.accessCode);
  const [passwordInput, setPasswordInput] = useState("");
  const [wrongPassword, setWrongPassword] = useState(false);
  const [showFullDescription, setShowFullDescription] = useState(false);
    const selected = Cookies.get("testItems");

const getInitialSelectedItem = (selected) => {
  try {
    return selected ? JSON.parse(selected) : null;
  } catch (error) {
    console.error("Error parsing selected:", error);
    return null;
  }
};

const [selectedItem, setSelectedItem] = useState(
  getInitialSelectedItem(selected)
);

useEffect(() => {
  if (selected) {
    try {
      setSelectedItem(JSON.parse(selected));
    } catch (e) {
      console.error("Failed to parse selected:", e);
    }
  }
}, [selected]);


  const handlePasswordChange = (e) => {
    setWrongPassword(false);
    setPasswordInput(e.target.value); // Update the input value whenever it changes
  };
  function formatMarkdown(markdown) {
    return markdown.replace(/\* /g, "\n* ");
  }
  const formattedMarkdown = formatMarkdown(ticket.notice);
  const handlePasswordSubmit = () => {
    if (passwordInput === ticket.accessCode) {
      setAccessGranted(true);
      setWrongPassword(false);
    } else {
      // alert("Wrong password!"); // This is just for the example, you can handle it in a better way.
      setWrongPassword(true);
    }
  };
  const toggleDescription = () => {
    setShowFullDescription(!showFullDescription);
  };

  const totalQuantity = selectedItem?.quantity??0;
  console.log(selectedItem);
  
  return (
    <div className={styles.wrapper}>
      <div className={styles.waves}>
        {wrongPassword && (
          <VerifyEmail
            title="Wrong Password"
            success={false}
            message="You entered the wrong password"
          />
        )}
        {waves.map((wave) => {
          console.log(wave);

          return (
            <div
              className={`${styles.wave} ${
                wave.waveStatus === "sold out" && !ticket.goToSeating
                  ? styles["wave-unavailable"]
                  : ""
              }`}
              key={wave.waveID}
            >
              {/* {wave.waveStatus === "available" && type === "single" && (
              <img src="/assets/ribbon.png" className={styles.ribbon} alt="" />
            )} */}
              {wave.waveStatus !== "available" && (
                <div className={styles.wave_status}>
                  {wave.waveStatus.toLowerCase() === "expired"
                    ? "sold out"
                    : wave.waveStatus}
                </div>
              )}
              {ticket.goToSeating ? (
                <div className={styles.top}>
                  <span>{waves.length === 1 ? name : wave.waveName}</span>
                  <div
                    className={styles.wave_status}
                    style={{ cursor: "pointer" }}
                    onClick={handleOpenCloseSeating}
                  >
                    Buy on map
                  </div>
                </div>
              ) : (
                <div className={styles.top}>
                  <span>{waves.length === 1 ? name : wave.waveName}</span>
                  {accessGranted && (
                    <div className={styles.counter}>
                      {wave.waveStatus === "available" && (
                        <>
                          <AiOutlineMinus
                            className={`${styles.logo} ${
                              quantities[wave.waveID] === 0
                                ? styles["logo-disabled"]
                                : ""
                            }`}
                            onClick={() =>
                              handleDecrement(
                                wave,
                                wave.maxPerOrder,
                                currency,
                                ticket,
                                event,
                                wave.minPerOrder,
                                ticket.incrementBy
                              )
                            }
                          />
                          <span>{quantities[wave.waveID]}</span>
                          <AiOutlinePlus
                            className={`${styles.logo} ${
                              quantities[wave.waveID] === wave.maxPerOrder ||
                              quantities[wave.waveID] +
                                (ticket.incrementBy || 1) >
                                wave.maxPerOrder
                                ? styles["logo-disabled"]
                                : ""
                            }`}
                            onClick={() => {
                              if (
                                quantities[wave.waveID] !== wave.maxPerOrder &&
                                quantities[wave.waveID] +
                                  (ticket.incrementBy || 1) <=
                                  wave.maxPerOrder
                              ) {
                                handleIncrement(
                                  wave,
                                  wave.maxPerOrder,
                                  currency,
                                  ticket,
                                  event,
                                  wave.minPerOrder,
                                  ticket.incrementBy
                                );
                              }
                            }}
                          />
                        </>
                      )}
                    </div>
                  )}
                </div>
              )}

              <div className={styles.price}>
                {accessGranted ? (
                  <span>
                    {event.eventID === "tNwv3xKd9U0uM3NxZEqx" &&
                    wave.waveStatus !== "available" ? (
                      <>
                        <br />
                      </>
                    ) : (
                      <>
                        {" "}
                        {wave.basePrice} {currency}
                      </>
                    )}
                  </span>
                ) : (
                  <>
                    {wave.waveStatus === "available" ? (
                      <div className={styles.access_code}>
                        <span className={styles.access_code_text}>
                          Access Code
                        </span>
                        <input
                          type="text"
                          className={styles.access_code_input}
                          onChange={handlePasswordChange}
                        />
                        <button
                          className={styles.button}
                          onClick={handlePasswordSubmit}
                        >
                          Submit
                        </button>
                      </div>
                    ) : (
                      <span>
                        {event.eventID === "tNwv3xKd9U0uM3NxZEqx" &&
                        wave.waveStatus !== "available" ? (
                          <>
                            <br />
                          </>
                        ) : (
                          <>
                            {" "}
                            {wave.basePrice} {currency}
                          </>
                        )}
                      </span>
                    )}
                  </>
                )}
              </div>
              {ticket.notice.length > 0 && (
                <>
                  <div
                    style={{
                      color: "black",
                      lineHeight: "normal",
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      cursor: "pointer",
                    }}
                    onClick={toggleDescription}
                    className={styles.descTicket}
                  >
                    <Markdown>Details</Markdown>
                    {formattedMarkdown.length > 50 && (
                      <button className={styles.toggleButton}>
                        {showFullDescription ? (
                          <MdOutlineKeyboardArrowUp />
                        ) : (
                          <MdOutlineKeyboardArrowDown />
                        )}
                      </button>
                    )}
                  </div>
                  <div
                    style={{ color: "black", lineHeight: "normal" }}
                    className={styles.descTicket}
                  >
                    <Markdown>
                      {showFullDescription
                        ? formattedMarkdown
                        : formattedMarkdown.slice(0, 0)}
                    </Markdown>
                  </div>
                </>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default WavePurchase;
